module.exports = __webpack_public_path__ + "static/img/dllogo.ca78d56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/dllogo.jpg
// module id = J8h3
// module chunks = 2